module.exports = __webpack_public_path__ + "img/ic-book.d0063f37.svg";